import { render, staticRenderFns } from "./dash.vue?vue&type=template&id=3fbc553d&"
import script from "./dash.vue?vue&type=script&lang=js&"
export * from "./dash.vue?vue&type=script&lang=js&"
import style0 from "./dash.vue?vue&type=style&index=0&id=3fbc553d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports